export const language = (process.env.REACT_APP_LANGUAGE as 'ua' | 'ru') || 'ua';
export const link_ua = 'https://www.radiosvoboda.org/a/32831284.html';
export const link_ru = 'https://www.radiosvoboda.org/a/32831285.html';
